<template>
    <b-modal
        ref="modalDelete"
        lazy
        title-tag="h2"
        title="Delete Item"
        ok-title="Proceed"
        footer-class="d-flex"
        no-close-on-backdrop
        no-close-on-esc
    >
        <p>
            {{ message }}
        </p>

        <template v-slot:modal-footer="{ close }">
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="proceed">
                Delete
            </b-button>
        </template>
    </b-modal>
</template>

<script type="text/javascript">
/**
 * @name ModalDeleteInventoryItem
 * @description modal to delete item
 * @see apps/application/controllers/inventory/item.php
 */

import Loader from "@/module/commons/loader";
import ItemServices from "@/services/items";
export default {
    components: {
        Loader
    },
    data() {
        return {
            recordId: null,
            isLoading: false,
            message: ""
        };
    },
    props: {},
    computed: {},
    methods: {
        async open(recordId) {
            this.recordId = recordId;
            this.loading = true;
            try {
                const res = await ItemServices.checkDeleteItem(this.recordId);

                if (typeof res.messages === "string") {
                    this.message = res.messages;
                } else {
                    throw true;
                }
                this.$refs.modalDelete.show();
            } catch (e) {
                this._message("Error on checking item deletion", "danger");
            }

            this.loading = false;
        },
        async proceed() {
            try {
                this.isLoading = true;
                await ItemServices.deleteItem(this.recordId);
                this._message("Record deleted.");
                this.$refs.modalDelete.hide();
                this.$emit("onsuccess");
            } catch (error) {
                this.isLoading = false;
                this._message(error.message, "danger");
            }
        }
    }
};
</script>
